import { z } from "zod";
import { emailSchema, mobilePhoneSchema, nameSchema, passwordSchema, } from "./common.js";
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, "Passwort erforderlich"),
});
export const registerFromInvitationSchema = z.object({
    token: z.string().min(20),
    firstName: nameSchema,
    lastName: nameSchema,
    password: passwordSchema,
    mobilePhone: mobilePhoneSchema,
});
export const verifyEmailSchema = z.object({
    token: z.string().min(20),
});
export const requestPasswordResetSchema = z.object({
    email: emailSchema,
});
export const resetPasswordSchema = z.object({
    token: z.string().min(20),
    password: passwordSchema,
});
//# sourceMappingURL=auth.js.map